import { cn } from '@jobcost-monorepo/utils';
import { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  title: string;
  label: string;
  className?: string;
}

export const LabelForm: React.FC<Props> = ({ title, label, className }) => {
  return (
    <div className={cn(className)}>
      <label className="block text-sm font-bold text-gray-700 dark:text-white">
        {title}
      </label>
      <div className="relative mt-1 rounded-md shadow-sm">
        <label className="block text-sm font-medium text-gray-700 dark:text-white">
          {label}
        </label>
      </div>
    </div>
  );
};

export default LabelForm;
